export const getServerEnvironmentVariable = () => process.env.SERVER_ENVIRONMENT || process.env.NODE_ENV
